<template>
  <v-card class="ma-3">
    <v-card-title>
      {{ $t("dialog.not_found.title") }}
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'not-found',
  data () {
    return {

    }
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style scoped>
</style>
